import "react/jsx-runtime";
import { useContext as t, createContext as e } from "react";
const o = e({
  dir: "ltr",
  toggleDirection: () => {
  },
  setDirection: () => {
  }
});
function n() {
  return t(o);
}
export {
  n as u
};
